import { render } from "./EmbargosPersonas.vue?vue&type=template&id=1ce8f5f6&scoped=true"
import script from "./EmbargosPersonas.vue?vue&type=script&lang=js"
export * from "./EmbargosPersonas.vue?vue&type=script&lang=js"

import "./EmbargosPersonas.vue?vue&type=style&index=0&id=1ce8f5f6&scoped=true&lang=css"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce8f5f6"]])

export default __exports__